import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconEquals = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.42857 4C2.63959 4 2 4.63959 2 5.42857C2 6.21755 2.63959 6.85714 3.42857 6.85714H10.5714C11.3604 6.85714 12 6.21755 12 5.42857C12 4.63959 11.3604 4 10.5714 4H3.42857ZM3.42857 8.28571C2.63959 8.28571 2 8.9253 2 9.71428C2 10.5033 2.63959 11.1429 3.42857 11.1429H10.5714C11.3604 11.1429 12 10.5033 12 9.71428C12 8.9253 11.3604 8.28571 10.5714 8.28571H3.42857Z",
		fill: "currentColor"
	})
});
export default SvgIconEquals;
